import type { NavigationItem } from '../extensions/navigation-item'

export const getDefaultRoute = (navigationItems: readonly NavigationItem[]) => {
  if (navigationItems?.length) {
    return navigationItems[0].pathname
  }
}
